import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaSelectTeamPage } from './plaza-select-team';

@NgModule({
  declarations: [
    PlazaSelectTeamPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaSelectTeamPage),
    TranslateModule.forChild()
  ],
})
export class PlazaSelectTeamPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-team/plaza-select-team.module.ts